<template>
  <ValidationObserver ref="observer">
    <b-row>
      <b-col>
        <component-header
          title="Create Privacy Setting"
          :isLoading="loading"
          :hasback="true"
          :hasSearch="false"
          :hasCreate="false"
          :hasReload="false"
          @back-press="backBtn"
        />
        <b-card>
          <div class="selections mb-4">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="type"
            >
              <div
                class="d-flex flex-column flex-md-row align-items-md-center mb-3"
              >
                <label class="mr-2">Select Type:</label>
                <b-form-radio-group
                  v-model="selectedType"
                  class="d-flex flex-row"
                >
                  <b-form-radio value="termsCondition" class="mr-3"
                    >Terms & Condition</b-form-radio
                  >
                  <b-form-radio value="privacyPolicy"
                    >Privacy Policy</b-form-radio
                  >
                </b-form-radio-group>
              </div>
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="scope"
            >
              <div
                class="d-flex flex-column flex-md-row align-items-md-center mb-3"
              >
                <label class="mr-2">Select Scope:</label>
                <b-form-radio-group
                  v-model="selectedScope"
                  class="d-flex flex-row"
                >
                  <b-form-radio value="customer" class="mr-3"
                    >Customer</b-form-radio
                  >
                  <b-form-radio value="seller" class="mr-3"
                    >Seller</b-form-radio
                  >
                  <b-form-radio value="agent">Agent</b-form-radio>
                </b-form-radio-group>
              </div>
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <b-form-group>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="title"
            >
              <b-form-input
                v-model="title"
                placeholder="Enter Title"
              ></b-form-input>
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </b-form-group>
        </b-card>

        <b-card
          v-for="(section, index) in subSections"
          :key="section.id"
          class="sub-section-card"
        >
          <div>
            <div class="d-flex justify-content-between align-items-center mb-2">
              <label
                >Sub Section {{ index + 1 }}
                <span v-if="index === 0" class="text-muted">(By Default)</span>
              </label>
              <div class="button-group">
                <b-button
                  v-if="index > 0"
                  variant="link"
                  class="p-0"
                  @click="removeSubSection(index)"
                >
                  <span class="fa fa-minus-circle fa-2x text-danger"></span>
                </b-button>
                <b-button variant="link" class="p-0" @click="addSubSection">
                  <span class="fa fa-plus-circle fa-2x text-success"></span>
                </b-button>
              </div>
            </div>

            <b-form-group>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="sub title"
              >
                <b-form-input
                  v-model="section.title"
                  placeholder="Enter Title"
                ></b-form-input>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </b-form-group>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="content"
            >
              <vue-editor v-model="section.content" class="mb-3"></vue-editor>
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
        </b-card>
        <div class="buttons d-flex justify-content-center mb-4">
          <b-button variant="outline-primary" @click="cancel">CANCEL</b-button>
          <b-button variant="primary" @click="save" class="ml-2">SAVE</b-button>
        </div>
      </b-col>
    </b-row>
  </ValidationObserver>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ComponentHeader from "@/components/componentNewHeader";

export default {
  name: "CreatePrivacySetting",
  components: {
    VueEditor,
    ComponentHeader,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      loading: false,
      selectedType: "",
      selectedScope: "",
      title: "",
      subSections: [{ id: Date.now(), title: "", content: "" }],
    };
  },
  methods: {
    backBtn() {
      this.$router.push({ path: "/privacy-setting/" });
    },
    addSubSection() {
      this.subSections.push({
        id: Date.now() + Math.random(),
        title: "",
        content: "",
      });
    },
    removeSubSection(index) {
      if (this.subSections.length > 1) {
        this.subSections.splice(index, 1);
      }
    },
    cancel() {
      this.$router.push({ path: "/privacy-setting/" });
    },
    async save() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const sections = this.subSections.map((section) => ({
        subtitle: section.title,
        description: section.content,
      }));

      const data = {
        tenant: this.$currentUserData._id,
        sections: sections,
        title: this.title,
        slug: this.selectedScope,
        content: this.selectedType,
      };

      await this.$store
        .dispatch("privacySetting/createPrivacySettingAction", data)
        .then((result) => {
          this.$swal({
            title: "Success",
            text: "Privacy setting added successfully!!",
            type: "success",
          });
          this.$router.push({ path: "/privacy-setting/" });
        });
    },
  },
};
</script>

<style>
.card {
  margin-top: 20px;
}

.selections {
  display: flex;
  flex-direction: column;
}

@media (min-width: 768px) {
  .selections {
    flex-direction: row;
    justify-content: space-between;
  }
}

.type-selection,
.scope-selection {
  display: flex;
  align-items: center;
}

.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.buttons {
  width: 50%;
  height: 40px;
  margin: auto;
  margin-top: 30px;
}

.sub-section-card {
  margin-top: 20px;
}
</style>
